const state = {};

const getters = {};

const actions = {
  getDMSLenders(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/push_to_dms/rci/get_dealer_lenders",
        request
      )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  setDMSLenders(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "post",
        "/api/push_to_dms/rci/save_dealer_lease_lenders",
        request
      )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  deleteDMSLenders(context, request) {
    return new Promise((resolve, reject) => {
      context.getters.CxmApiClient.ProcessRequest(
        "delete",
        "/api/push_to_dms/rci/delete_dealer_lenders",
        request
      )
        .then(response => {
          if (response && response.data.successful) {
            resolve(response.data.data);
          } else {
            reject(response);
          }
        })
        .catch(err => {
          reject(err.response);
        });
    });
  },
  async getDMSUsers(context, request) {
    let response = await context.getters.CxmApiClient.ProcessRequest("POST", `/api/push_to_dms/get_dms_user_ids`, request.payload).catch((ex) => ex.response);
    return response;
  },

};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/DMSSettings.js